import { jsx, jsxs } from "react/jsx-runtime";
import { memo } from "react";
import {
  Line,
  Path,
  Rect,
  Svg
} from "react-native-svg";
import { themed } from "../themed";
const Icon = (props) => {
  const { color = "black", size = 24, ...otherProps } = props;
  return /* @__PURE__ */ jsxs(
    Svg,
    {
      width: size,
      height: size,
      viewBox: "0 0 24 24",
      fill: "none",
      stroke: `${color}`,
      strokeWidth: "2",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      ...otherProps,
      children: [
        /* @__PURE__ */ jsx(
          Rect,
          {
            width: "18",
            height: "18",
            x: "3",
            y: "3",
            rx: "2",
            ry: "2",
            stroke: `${color}`
          }
        ),
        /* @__PURE__ */ jsx(Line, { x1: "3", x2: "21", y1: "15", y2: "15", stroke: `${color}` }),
        /* @__PURE__ */ jsx(Path, { d: "m9 10 3-3 3 3", stroke: `${color}` })
      ]
    }
  );
};
Icon.displayName = "PanelBottomOpen";
const PanelBottomOpen = memo(themed(Icon));
export {
  PanelBottomOpen
};
//# sourceMappingURL=panel-bottom-open.js.map
